export class CustomerSelectItem {
  Id: number;
  Name: string;
}
export class ApplicationSelectedItem {
  Id: number;
  Name: string;
  Default: boolean;

}
export class JobsiteSelectItem {
  Id: number;
  Name: string;
}
export class FamilySelectItem {
  Id: number;
  Name: string;
  ShowPropelHrsPerc: boolean;
}
export class EquipmentSelectItem {
  Id: number;
  SerialNumber: string;
  UnitNumber: string;
  AddiUnitNumber: string;
}
export class Equipment {
  Id: number;
  CustomerId: number;
  JobsiteId: number;
  SerialNumber: string;
  UnitNumber: string;
  MakeId: number;
  ModelId: number;
  ForecastId: number;
  Smu: number;
  Ltd: number;
  Date: Date;
  Photo: string;
  HoursOfUsePerDay: number;
  AvgDistance: number;
  UsedMonday: boolean;
  UsedTuesday: boolean;
  UsedWednesday: boolean;
  UsedThursday: boolean;
  UsedFriday: boolean;
  UsedSaturday: boolean;
  UsedSunday: boolean;
  InspectEvery: number;
  InspectEveryUnitTypeId: number;
  ApplicationId: number;
  RankingId: number;
  StatusId: number;
  CreatedByUserId: number;
  CanChangeSmuLtd: number;
  UnsyncedId: number = 0;
  EnableAutoInspectionPlanner: boolean = false;
  NextInspectionDate: Date;
  Bcm: number;
  Ton: number;
  SetupDate: string;
  AdditionalUnitNo: string;
  Pmu: number;
  EnableDistTravelledTracking: boolean;
  ShowPropelHrsPerc: boolean;
  DistanceForward: number;
  DistanceReverse: number;
  DistanceForwardatSetup: number;
  DistanceReverseatSetup: number;
  Calculatemethod: number;
  SystemCalculated: boolean;
  InputAverageCalculated: boolean;
  CalculateLastInspections: boolean;
  CalculateDisplayStatus: boolean;
  ManualHours: number;
  ManualDate: Date;
  NextPmDate: Date;
  SecondPmDate: Date;
  FloatingDate1: Date;
  FloatingDate2: Date;
  ForecastMethod: number;
  SafetyCheck: boolean;
  SafetyCheckValue: number;
  ShowLastInspWorn: boolean;
  ShowWornToday: boolean;
  DistanceRatio: number;
}



export class EquipmentInspectionForcastingViewModel {
  Id: number;
  JobsiteId: number;
  CreatedByUserId: number;

  HoursOfUsePerDay: number;
  UsedMonday: boolean;
  UsedTuesday: boolean;
  UsedWednesday: boolean;
  UsedThursday: boolean;
  UsedFriday: boolean;
  UsedSaturday: boolean;
  UsedSunday: boolean;
  InspectEvery: number;
  InspectEveryUnitTypeId: number;
  EnableAutoInspectionPlanner: boolean = false;
  AvgDistance: number;
  CalculateMethod: number;
  CalculateDisplayStatus: boolean;
  ForecastMethod: number;
  ManualHours: number;
  ManualDate: Date;
  ManualDateStr: string;
  SafetyCheck: boolean;
  SafetyCheckValue: number;
  ShowLastInspWorn: boolean;
  ShowWornToday: boolean;
  DistanceRatio: number;
}



export class UnsyncedEquipmentInfoViewModel {
  public Id: number;
  public SerialNumber: string;
  public UnitNumber: string;
  public Smu: number;
  public LTD: number;
  public CustomerId: number;
  public JobsiteIdCRSF: number;
}

export class UcPlannerDetail {
  Id: number;
  InspectionId: number;
  CustomerId: number;
  CustomerName: string;
  Serial: string;
  Unit: string;
  LastKnownSmu: number;
  LastKnownDistance: number;
  LastKnownDate: Date | null;
  ModelDesc: string;
  HasInspection: boolean;
  DateEnter: Date | null;
  NextPmDate: Date | null;
  PmServiceNextPmDate: number;
  SecondPmDate: Date | null;
  PmServiceSecondPmDate: number;
  FloatingDate1: Date | null;
  PmServiceFloatingDate1: number;
  FloatingDate2: Date | null;
  PmServiceFloatingDate2: number;
  EnterSmu: number;
  EnterDoe: number;
  LastInspectionDate: Date;
  LastInspectionSMU: number;
  loading: boolean;
  EnabledDistanceTracking: boolean
  ForwardDistance: number;
  ReverseDistance: number;
  ForwardDistanceSave?: number;
  ReverseDistanceSave?: number;
  PmServiceNextPmDateS: string;
  PmServiceSecondPmDateS: string;
  PmServiceFloatingDate1S: string;
  PmServiceFloatingDate2S: string;
  DistanceRatio: number;
  IsEstimated: boolean=false;
  IsEstimatedDistance: boolean=false;
}

export class UcFleetEquipmentDetail {
  EquipmentId: number;  // Equipment ID
  CustomerId: number;  // Customer ID
  CustomerName: string;  // Customer Name
  Serial: string;  // Serial Number
  JobsiteId: number;  // Jobsite ID
  JobsiteName: string;  // Jobsite Name
  Family: string;  // Equipment Family
  FamilyId: number;  // Equipment Family ID
  Make: string;  // Equipment Make
  MakeId: number;  // Equipment Make ID
  Model: string;  // Equipment Model
  ModelId: number;  // Equipment Model ID
  Unit: string;  // Unit Number
  NextInspectionDate: Date;  // Next Inspection Date (Optional)
  NextInspectionSMU?: number;  // Next Inspection SMU (Optional)
  SMU?: number;  // Current SMU (Optional)
  LTD?: number;  // LTD at Start (Optional)
  AdditionalUnitNo: string;  // Additional Unit Number
  IsExpanded: boolean = false;
  IsGraphLoader: boolean = false;
  HadApiCall: boolean;
  UCPlannerComponent: UCPlannerComponent[] = [];
  LastInspectionWornPer: number;
  WornPercentageToday: number;
  LastInspectionWorn: number;
  WornAtNextPmService: number;
  WornAtSecondPmService: number;
  DateAt120Worn: Date;
  DateAt100Worn: Date;
  WeeklyBudget: number[];
  GraphData: GraphComponentData[] = [];
  Weekly: WeeklyQuoteSummary[];
  NextPmDays: number;
  SecondPmDays: number;
  FloatingPm1Days: number;
  FloatingPm2Days: number;
  NextPmDate: Date;
  SecondPmDate: Date;
  FloatingPm1Date: Date;
  FloatingPm2Date: Date;
  Summary: UcFleetEquipmentSummary[] = []
  DaysArr: number[] = [];
PM1ServiceTypeName: string;
PM2ServiceTypeName:string;
Floating1ServiceTypeNameL:string;
Floating2ServiceTypeName:string;
LastPmSMU:number;
LastPmDOE:number;
TodaySMU:number;
TodayDOE:number;
NextPmDOE:number;
NextPmSMU:number;
SecondPmSMU:  number;
SecondPmDOE:number;
FloatingPm1SMU: number;
FloatingPm2SMU: number;
FloatingPm1DOE: number;
FloatingPm2DOE: number;
LastPmDate:Date;
  TodayDate:Date
  LastInspectionId:number;
}

export class UcFleetEquipmentSummary {
  ActionDate: Date;
  Price: number;
  ActionCode: string;
  ActionDateDays: number
}


export class UcFleet {
  Jobsiteid: number;
  FamilyId: number;
  MakeId: number;
  Modelid: string;
  CustomerId: number;
}

export class UCPlannerComponent {
  EquipmentId: number;
  EqunitAuto: number;
  CompartTypeAuto: number;
  CompartPosition: number;
  CompartSide: number;
  LastInspectionWorn: number;
  WornPercentageToday: number;
  SmuAtNextPm: number;
  DocAtNextPm: number;
  SmuAtSecondPm: number;
  DocAtSecondPm: number;
  WornPercentage: number;
  WornAtNextPmService: number;
  WornAtSecondPmService: number;
  IsExpanded: boolean = false;
  DateAt120Worn: Date;
  DateAt100Worn: Date;
  GroupNumber: number;
  SystemType: string;
  WorstWornOnLastinspction: number;
  WorstWornOnNextPm: number;
  WorstWornOnSecondPm: number;
  WorstWornOnToday: number;

}

export class UcPlannerComponnetArr {
  ucPlannerComp: UCPlannerComponent[]
}

export class UcActionRecommedSearch {
  CustomerId: number;
  JobsiteId: number;
  FamilyId: number;
  MakeId: number;
  ModelId: string;
  EquipmentId: number;
  UnitAuto: string;
  StatusId: number;
  ActionDate: Date;
}

export class UcPlannerTrackQuoteDetailVm {
  Data: UcPlannerTrackQuoteDetail[] = [];
  Status: number;
  Message: string;
}

export interface UcPlannerTrackQuoteDetail {
  QuoteAuto: number;
  QuoteName: string;
  QuoteDetailAuto: number;
  UnitNo: string;
  ModelDesc: string;
  Side: string;
  Pos: number;
  ActionDescription: string;
  SeverityCategory: string;
  TakeAction: number;
  HoursGained: number;
  Price: number;
  Comment: string;
  StatusId: number;
  StatusName: string;
  ActionDate: Date;
  IsChecked: boolean;
}


export class UcPlannerData {
  ColumnId: number;
  Check: boolean;
  UserId: number;
}

export class UcPlannerDataVM {
  Data: UcPlannerData;
  StatusId: number;
  Message: string;
}

export class ColumnList {
  Make: boolean = true;
  LastInspection: boolean = true;
  AVGDailyUse: boolean = true;
  Position: boolean = true;
  NextPmService: boolean = true;
  SecondPmService: boolean = true;
  FloatingPm1Service: boolean = true;
  FloatingPm2Service: boolean = true;
  Worn_100: boolean = true;
  Worn_120: boolean = true;
  CMU: boolean = true;
  DOC: boolean = true;
  
}

export class ActionQuoteCheck {
  StatusId: number;
  ActionQuoteDetail: ActionQuoteDetailId[] = [];
}
export class ActionQuoteDetailId {
  QuoteDetailId: number;
}


export class EquipmentQuoteSummary {
  EquipmentId: number;
  Serial: string;
  JobsiteName: string;
  Family: string;
  Make: string;
  Model: string;
  Unit: string;
  TotalComponent: number;
  MaxSeverityId: number;
  SeverityCategory: string;
  Smu: number;
  Cost: number;
  OldestDate: string; // Use string if dates come as ISO strings (e.g., from JSON)
  IsExpanded: boolean = false;
  UcPlannerTrackQuoteDetail: UcPlannerTrackQuoteDetail[];
  ActionCode: string;

}

export class EquipmentQuoteSummaryVm {
  Data: EquipmentQuoteSummary[] = [];
  Status: number;
  Message: string;
}

export class ResponseM {
  Status: number;
  Message: string;
}
export class UcPlannerStatusUpdate {
  StatusId: number;
  Message: string;
}

export class PmServiceTypesVM {
  Data: PmServiceTypes[] = [];
  StatusId: number;
  Message: string;
}

export class PmServiceTypes {
  TypeId: number;
  TypeName: string;
}

export class UcPlannerGrapVm {
  Data: UcPlannerGrapCompVm;
  Status: number;
  Message: string;
}

export class UcPlannerGrapHeadingsVm {
  Data: GraphHeaderData[];
  Status: number;
  Message: string;
}

export class UcPlannerGrapCompVm {
  GraphData: GraphComponentData[];
  WeekData: GraphHeaderData[];
}


export class GraphHeaderData {
  MonthName: string;
  MonthlyBudget: number;
  WeekStart: string;
  WeekEnd: string;
  WeekNo: number;
  WeekLyBudget: number;
  YearNo: number;
}
export class GraphComponentData {
  GroupNumber: number;
  SystemType: string;
  SystemTypeIndex: number;
  CompartSide: number;
  CompartTypeAuto: number;
  EquipmentId: number;
  EqunitAuto: number;
  CompartName: string;
  CompartPosition: number;
  CMU: number;
  ResidualLife100: number;
  ResidualLife120: number;
  DaysFor100: number;
  DaysFor120: number;
  DaysFor100Arr: number[] = [];
  DaysFor120Arr: number[] = [];
  Date100PercentWorn: Date;
  Date120PercentWorn: Date;
  QuoteData: QuoteDetailResult[];
  DaysForRecommA: number;
  DaysForRecommArr: any[] = [];
  CalcualtedDateForRecom: Date;
  DaysForNextReplacementRecommArr: any[] = [];
  DaysForReplacement: number;
  TodayDateDays: number;
  DaysArr: number[] = [];
}
export class QuoteDetailResult {
  QuoteDetailAuto: number;
  ComponentId: number;
  Comment: string;
  PlaceholderNA: string;
  PartsCost: number;
  MiscCost: number;
  LabourCost: number;
  TotalCost: number;
  StartActionAtSmu: number;
  CompleteActionBySmu: number;
  PositionLabel: string;
  Side: string;
  ActionDescription: string;
  OpTypeAuto: number;
  QuoteAuto: number;
  ActionDate: Date;
}

export class QuoteDetailResultVm {
  Data: QuoteDetailResult[];
  Status: number;
  Message: string;
}

export class DisplayOptionDate {
  Sdate: Date;
  Edate: Date;
  Month: number;
}

export class WeeklyQuoteSummary {
  WeekStartDate: Date;
  WeekNo: number;
  TotalWeekPrice: number;
  WeekYear: number;
}

export class MonthlyQuoteSummary {
  MonthYear: string;
  MonthName: string;
  YearNo: number;
  TotalMonthPrice: number;
}

export class MonthlyQuoteSummaryVM {
  Month: MonthlyQuoteSummary[];
  Weekly: WeeklyQuoteSummary[];
  Status: number;
  Message: string;
}



